import React from 'react';
import Swiper from 'react-id-swiper';
import I18n from '../../../i18n/I18n';
import Title from '../../common/widgetTitle/WidgetTitle';
import OrderCard from '../../dashboard/orderCard/OrderCard';
import styles from './OrderSummary.scss';

const NewOrders = (props: Object) => {
  const params = {
    paginationClickable: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    containerClass: styles.containerClass,
    spaceBetween: 10,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true
  };

  const data = props.data;

  const browser = props.browser;


  let slidesCount = 4.5;

  if (browser.lessThan.phablet) {
    slidesCount = 1.5;
  } else if (browser.lessThan.tablet) {
    slidesCount = 2.5;
  } else if (browser.lessThan.largeDesktop) {
    slidesCount = 3.5;
  } else {
    slidesCount = 4.5;
  }

  const card = slides =>
    <Swiper {...params} containerClass={styles.horizontalContainer} slidesPerView={slides} freeMode>
      {data && data.today
        ? <div>
            <OrderCard
              data={data.today}
              day={I18n.getText('summary.today', {}, 'Today')}
              currencyCode={props.currencyCode}
            />
          </div>
        : ''}
      {data && data.yesterday
        ? <div>
            <OrderCard
              data={data.yesterday}
              day={I18n.getText('summary.yesterday', {}, 'Yesterday')}
              currencyCode={props.currencyCode}
            />
          </div>
        : ''}
      {data && data.last_7_days
        ? <div>
            <OrderCard
              data={data.last_7_days}
              day={I18n.getText('summary.last-7-days', {}, 'Last 7 Days')}
              currencyCode={props.currencyCode}
            />
          </div>
        : ''}
      {data && data.last_30_days
        ? <div>
            <OrderCard
              data={data.last_30_days}
              day={I18n.getText('summary.last-month', {}, 'Last Month')}
              currencyCode={props.currencyCode}
            />
          </div>
        : ''}
      {data && data.last_90_days
        ? <div>
            <OrderCard
              data={data.last_90_days}
              day={I18n.getText('summary.last-3-months', {}, 'Last 3 Months')}
              currencyCode={props.currencyCode}
            />
          </div>
        : ''}
      {data && data.last_365_days
        ? <div>
            <OrderCard
              data={data.last_365_days}
              day={I18n.getText('summary.last-year', {}, 'Last Year')}
              currencyCode={props.currencyCode}
            />
          </div>
        : ''}
    </Swiper>;

  return (
    <div className={styles.ctr}>
      <Title
        title={I18n.getText('dashboard.orders', {}, 'Orders')}
        enableBtn
        btnText={I18n.getText('dashboard.view-all', {}, 'View All')}
        btnLink={'/orders'}
      />
      <div className={styles.cardWrapper}>
        {card(slidesCount)}
      </div>
      <div className="swiper-pagination" />
    </div>
  );
};

export default NewOrders;



// WEBPACK FOOTER //
// ./src/components/dashboard/orderSummary/OrderSummary.js